import React, { useEffect } from 'react'

const PlayerQuests = ({ gameData, playerData }) => {

    useEffect(() => {
        document.getElementById(`head-logo`).scrollIntoView({'behavior': 'smooth'});
        const btns = document.getElementsByClassName('menu-btn')
        for (let btn of btns) {
            btn.classList.remove('active');
        }
        document.getElementById('quests').classList.add('active');
    }, []);

    return (
        <div>PlayerQuests</div>
    )
}

export default PlayerQuests